import { Component, ElementRef, ViewChild } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { Api } from "src/app/services/api";
import { Globals } from "src/app/services/globals";
import { IPosterOrder } from "../../../../../../../common/common-interfaces/poster-order";
import moment from 'moment';
@Component({
    selector: "store-home",
    templateUrl: "./home.component.html",
    styleUrls: ["./home.component.scss"],
    standalone: false
})
export class StoreHomeComponent {
  todoOrders: IPosterOrder[] = [];
  hasTodo = false;
  todoLoaded = false;
  orderStatuses: any;
  constructor(
    private api: Api,
    private router: Router,
    private route: ActivatedRoute,
    public globals: Globals,
    private sanitizer: DomSanitizer,
  ) {
  }

  async ngOnInit() {
    await this.fetchPendingOrders();
    await this.updateTodoStatus();
    await this.fetchOrderStatuses();
  }


  async fetchPendingOrders() {
    let periodStart = moment().subtract(4, 'weeks').toDate();
    let periodEnd = moment().toDate();
    let pendingOrders = await this.api.store().get<any>(`/poster-orders?statuses=PENDING&startDate=${moment(periodStart).startOf('day').toISOString()}&endDate=${moment(periodEnd).endOf('day').toISOString()}`);

    this.todoOrders = pendingOrders.filter((order: IPosterOrder) => {
      return order.items.some((item) => {
        return item.status == 'AWAITING_PRINT_FILE' || item.status == 'UNKNOWN';
      });
    });

  }

  async fetchOrderStatuses() {
    let periodStart = moment().subtract(2, 'months').toDate();
    let periodEnd = moment().toDate();
    this.orderStatuses = await this.api.store().get<any>(`/poster-orders/by-status?startDate=${moment(periodStart).startOf('day').toISOString()}&endDate=${moment(periodEnd).endOf('day').toISOString()}`);

  }

  async updateTodoStatus() {
    if (this.todoOrders.length)
      this.hasTodo = true;

    this.todoLoaded = true;
  }

  ngOnDestroy(): void {


  }
}
